import { ReactNode } from 'react';
import { ResizablePane } from '@rossum/components/resizable-pane/ResizablePane';
import { Stack } from '@rossum/ui/material';
import { SplitSidebarFooter } from './SplitSidebarFooter';

type SplitSidebarProps = {
  onConfirm?: () => void;
  confirmInProgress?: boolean;
  hasChanges?: boolean;
  onNavigatePreviousAnnotation?: () => void;
  onNavigateNextAnnotation?: () => void;
  /** Scroll-area content; empty until the split editing controls land. */
  children?: ReactNode;
};

export const SplitSidebar = ({
  onConfirm,
  confirmInProgress,
  hasChanges,
  onNavigatePreviousAnnotation,
  onNavigateNextAnnotation,
  children,
}: SplitSidebarProps) => (
  <ResizablePane
    storageKey="document-split:sidebar-width"
    paneConfig={{ min: 400, max: 700, initial: 400 }}
  >
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        borderRight: theme => `1px ${theme.palette.divider} solid`,
      }}
      data-cy="split-screen-sidebar"
    >
      <Stack
        id="split-sidebar-scrollable"
        sx={{
          width: '100%',
          flex: '1 1 auto',
          minHeight: 0,
          backgroundColor: 'background.paper',
          position: 'relative',
          overflowY: 'auto',
          p: 1,
        }}
        data-cy="split-sidebar-scrollable"
      >
        {children}
      </Stack>
      <SplitSidebarFooter
        onConfirm={onConfirm}
        confirmInProgress={confirmInProgress}
        hasChanges={hasChanges}
        onNavigatePreviousAnnotation={onNavigatePreviousAnnotation}
        onNavigateNextAnnotation={onNavigateNextAnnotation}
      />
    </Stack>
  </ResizablePane>
);
